<template>
  <div class="category-counter-view">
    <div class="icon-block">
      <div class="icon-bg"><BaseSpriteIcon :icon-name="icon" /></div>
    </div>
    <div class="text-block">
      <div class="category-value">{{ value }}</div>
      <div>{{ category }}</div>
    </div>
  </div>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
export default {
  name: 'CategoryCounter',
  components: {
    BaseSpriteIcon
  },
  props: {
    category: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    },
    icon: {
      type: String,
      default: 'ico-add-circle-outline'
    }
  }
};
</script>

<style lang="less">
.category-counter-view {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .icon-block {
    flex-grow: 1;
  }

  .icon-bg {
    width: 36px;
    height: 36px;
    background: var(--primary-color);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 18px;

    svg {
      fill: #ffffff;
    }
  }

  .text-block {
    flex-shrink: 0;
    display: block;
    flex-direction: column;
    font-weight: 500;
  }

  .category-value {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
  }
}
</style>
